<template>
  <div class="full-view"
       :style="'background-image: url(\'' + settings.staticImageUrl + '/404-background.jpg\')'"
  >
    <mdb-mask class="gradient d-flex justify-content-center align-items-center overflow-auto">
      <mdb-card>
        <mdb-card-header class="warning-color text-white">
          <h5>Not Found
            <mdb-icon icon="sad-tear"/>
          </h5>
        </mdb-card-header>
        <mdb-card-body class="text-left">
          <h5>The page {{pathTried}} does not exist.</h5>
        </mdb-card-body>
      </mdb-card>
    </mdb-mask>
  </div>
</template>

<script>
import {mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbContainer, mdbIcon, mdbMask, mdbView} from 'mdbvue';

export default {
  name: 'NotAuthorized403',
  components: {
    mdbContainer,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbIcon,
    mdbMask,
    mdbView,
    mdbBtn
  },
  props: {
    // Will be populated if your route uses: props: route => ({ attemptedPath: route.fullPath })
    attemptedPath: {
      type: String,
      default: '',
    },
  },

  computed: {
    loggedIn: function () {
      return this.$store.state.loggedIn
    },
    settings: function () {
      return this.$store.state.settings
    },
    pathTried() {
      return this.attemptedPath || this.$route.fullPath;
    },

  }
}

</script>
<style scoped>
.gradient {
  background: -moz-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  background: -webkit-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  background: -webkit-gradient(linear, 45deg, from(rgba(42, 27, 161, 0.7)), to(rgba(29, 210, 177, 0.7)));
  background: -o-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  background: linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  height: calc(100vh);
}

.full-view {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: calc(100vh);
}
</style>
